
<!--<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li *ngIf="user.role === 'ACCOUNT_OWNER'" class="breadcrumb-item" id="accountOwnerHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li aria-current="page" class="breadcrumb-item active">Marketing</li>
    </ol>
  </nav>

  <form>
    <div class="row">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of allOrdersMainMenu" >
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked);"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
          &lt;!&ndash;<li class="list-inline-item">
            <a aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" href="#" role="button">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of ordersMainMenu">
                <a (click)="populateTabData(om.tabClicked);switchPosition(om)" *ngIf="om.additional === 'Y'"
                   [ngClass]="{'active': tabClicked === om.tabClicked}"
                   class="dropdown-item">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>&ndash;&gt;
        </ul>
        <select (change)="populateTabData(userDrop2);" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}"
                class="form-control MobileContent" id="use2r" required
                style="width: 140px;">
          <option *ngFor="let u of allOrdersMainMenu" [ngValue]="u.tabClicked">{{u.displayName}}</option>
        </select>
      </div>
    </div>



    <div *ngIf="tabClicked === 'trackBanner'" class="">
      <app-tracking-page-banner></app-tracking-page-banner>
    </div>
    <div [ngClass]="{'show-sec': tabClicked === 'trackMenu'}" class="row hide-sec">
      <app-tracking-page-menu></app-tracking-page-menu>
    </div>


  </form>
  </section-->

<section class="main-section" xmlns="http://www.w3.org/1999/html">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li *ngIf="user.role === 'ACCOUNT_OWNER'" class="breadcrumb-item" id="accountOwnerHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li aria-current="page" class="breadcrumb-item active">Marketing</li>
    </ol>
  </nav>

  <form>
    <div class="row">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of allOrdersMainMenu" >
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked);"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
          <!--<li class="list-inline-item">
            <a aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" href="#" role="button">+ more</a>
            <div class="dropdown-menu dropdown-menu2">
              <ng-container *ngFor="let om of ordersMainMenu">
                <a (click)="populateTabData(om.tabClicked);switchPosition(om)" *ngIf="om.additional === 'Y'"
                   [ngClass]="{'active': tabClicked === om.tabClicked}"
                   class="dropdown-item">{{om.displayName}}</a>
              </ng-container>
            </div>
          </li>-->
        </ul>
        <select (change)="populateTabData(userDrop2);" [(ngModel)]="userDrop2" [ngModelOptions]="{standalone: true}"
                class="form-control MobileContent" id="use2r" required
                style="width: 140px;">
          <option *ngFor="let u of allOrdersMainMenu" [ngValue]="u.tabClicked">{{u.displayName}}</option>
        </select>
      </div>
    </div>



    <div *ngIf="tabClicked === 'trackBanner'" class="">

      <section>
        <div class="col ">
          <div class="inner-box">
            <div class="col-md-3">
              <label>Web view Banner</label>
              <div class="upload-box" *ngIf="!imageUrl">
                <input type="file" id="uploadLogo" (change)="loadImage($event)">
                <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                <div>upload logo</div>
              </div>
              <div class="upload-box mt-2" *ngIf="imageUrl">
                <img class="shift-uploaded-img shift-image"
                     src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="250" height="250"/>
                <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
                <!--           <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="150" height="150"/>
                           <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="100" height="100"/>
                           <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="50" height="50"/>-->
                <div class="overly">
                  <button class="btn">
                    <input type="file" id="upload" class="plus-upload-btn" (change)="loadImage($event)">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Upload
                  </button>
                  <button class="btn" id="remove" (click)="ignoreImage()">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt">
              <label>Mobile view Banner</label>
              <div class="upload-box" *ngIf="!imageUrlMobile">
                <input type="file" id="uploadLogo" (change)="loadImageMobile($event)">
                <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                <div>upload logo</div>
              </div>
              <div class="upload-box mt-2" *ngIf="imageUrlMobile">
                <img class="shift-uploaded-img shift-image"
                     src="{{imageUrlMobile !=null ? imageUrlMobile : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="250" height="250"/>
                <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessageMobile">{{errorMessageMobile}}</div>
                <!--           <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="150" height="150"/>
                           <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="100" height="100"/>
                           <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img"
                                src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                                width="50" height="50"/>-->
                <div class="overly">
                  <button class="btn">
                    <input type="file" id="upload" class="plus-upload-btn" (change)="loadImageMobile($event)">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Upload
                  </button>
                  <button class="btn" id="remove" (click)="ignoreImageMobile()">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            </div>


            <form class="mt-4">
              <div class="form-group m-3">
                <div class="form-group ">
                  <label class="control-label" for="altText">Alternate Text</label>
                  <input (blur)="typeAlter()" [(ngModel)]="track1.altText" [ngModelOptions]="{standalone:true}"
                         [ngClass]="{'is-invalid':alterError}"
                         class="form-control" id="altText" maxlength="30"
                         type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 122 || event.charCode >= 65 && event.charCode <=90'
                         required >

                  <div [hidden]="!alterError" class="invalid-feedback d-block shift-invalid-login" id="alterError">
                    {{alterError}}
                  </div>
                </div>
              </div>

              <div class="form-group m-3">
                <div class="form-group ">
                  <label class="control-label" for="bannerUrl">Banner Url</label>
                  <input (blur)="typeBannerUrl()" [(ngModel)]="track1.bannerUrl" [ngModelOptions]="{standalone:true}"
                         [ngClass]="{'is-invalid':bannerUrlError}"
                         class="form-control" id="bannerUrl" maxlength="30"
                         type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 122 || event.charCode >= 65 && event.charCode <=90'
                         required >

                  <div [hidden]="!bannerUrlError" class="invalid-feedback d-block shift-invalid-login" id="bannerUrlError" >
                    {{bannerUrlError}}
                  </div>
                </div>
              </div>



              <div class="col text-right">
                <button  class="btn btn-orange" id="save" type="submit" (click)="TrackingBannerService()">Save</button>

              </div>


            </form>
          </div>

        </div>

      </section>




    </div>


    <div [ngClass]="{'show-sec': tabClicked === 'trackMenu'}" class="row hide-sec">



      <div class="inner-box" *ngIf="trackMenuDisplay !== 'T'">
        <div class="row p-4 d-flex justify-content-center">
          <div class=" col-4">
            <div class="form-group ">
              <label class="control-label" for="menuName">Menu Name</label>
              <input (blur)="typemenuName()" [(ngModel)]="menuName" [ngModelOptions]="{standalone:true}"
                     [ngClass]="{'is-invalid':menuNameError}"
                     class="form-control" id="menuName"
                     type="text"
                     required >

              <div [hidden]="!menuNameError" class="invalid-feedback d-block shift-invalid-login" id="menuNameError">
                {{menuNameError}}
              </div>
            </div>
          </div>

          <div class=" col-4 ">
            <div class="form-group ">
              <label class="control-label" for="menuUrl">Menu Url</label>
              <input (blur)="typemenuUrl()" [(ngModel)]="menuUrl" [ngModelOptions]="{standalone:true}"
                     [ngClass]="{'is-invalid':menuUrlError}"
                     class="form-control" id="menuUrl"
                     type="text"
                     required >

              <div [hidden]="!menuUrlError" class="invalid-feedback d-block shift-invalid-login" id="menuUrlError">
                {{menuUrlError}}
              </div>
            </div>
          </div>
          <div class="col-4 text-center">
            <!--<button class="btn btn-cancel" id="delete" ngbTooltip="Delete"
                    placement="bottom" type="submit"><i class="fa fa-trash-o"
                                                        style="color:#ee7125"></i>-->
            <button class="btn btn-outline-primary" style="position:relative;margin-top:29px;" (click)="manageTrackingMenu()"> save
            </button>
          </div>
        </div>
<!--
        <div class="row p-4 d-flex justify-content-center" *ngIf="track.menuName !== null && track.menuUrl !==null">
          <div class=" col-4">
            <div class="form-group ">
              <label class="control-label" for="menuName1">Menu Name</label>
              <input (blur)="typemenuName()" [(ngModel)]="track.menuName" [ngModelOptions]="{standalone:true}"
                     [ngClass]="{'is-invalid':menuNameError}"
                     class="form-control" id="menuName1" maxlength="30"
                     type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 122 || event.charCode >= 65 && event.charCode <=90'
                     required [disabled]="disableStatuses" >

              &lt;!&ndash;<div [hidden]="!menuNameError" class="invalid-feedback d-block shift-invalid-login" id="menuNameError">
                {{menuNameError}}
              </div>&ndash;&gt;
            </div>
          </div>

          <div class=" col-4 ">
            <div class="form-group ">
              <label class="control-label" for="menuUrl1">Menu Url</label>
              <input (blur)="typemenuUrl()" [(ngModel)]="track.menuUrl" [ngModelOptions]="{standalone:true}"
                     [ngClass]="{'is-invalid':menuUrlError}"
                     class="form-control" id="menuUrl1" maxlength="30"
                     type="text" onkeypress='return event.charCode >= 90 && event.charCode <= 122 || event.charCode >= 65 && event.charCode <=90'
                     required [disabled]="disableStatuses">

              &lt;!&ndash;<div [hidden]="!menuUrlError" class="invalid-feedback d-block shift-invalid-login" id="menuUrlError">
                {{menuUrlError}}
              </div>&ndash;&gt;
            </div>
          </div>
          <div class="col-4 text-center mt-4">
            &lt;!&ndash;<button class="btn btn-cancel" id="delete" ngbTooltip="Delete"
                    placement="bottom" type="submit"><i class="fa fa-trash-o"
                                                        style="color:#ee7125"></i>&ndash;&gt;
            <a data-toggle="modal" data-target="#deleteReturnModal1" (click)="selectedDeleteReturn()"
               class="p-2 ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                <defs><style>.a{fill:#848484;}</style></defs>
                <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
              </svg>
            </a>
          </div>
        </div>
-->
      </div>


          <div class="inner-box mb-3" style="overflow:overlay;" [hidden]="!trackingMenuList?.length">
            <table class="table table-stripe">
              <thead>
              <tr>
                <th>Menu Name</th>
                <th>Menu Url</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let trackDetails of trackingMenuList">
                <td>{{trackDetails.menuName}}</td>
                <td>{{trackDetails.menuUrl}}</td>
                <td><a (click)="deleteReturn(trackDetails)">
                  <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                    <defs>
                      <style>.a {
                      fill: #848484;
                    }</style>
                    </defs>
                    <path class="a"
                          d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                          transform="translate(-7.5 -4.5)"/>
                  </svg>
                </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

    </div>


  </form>


  <!--<div class="container text-center">
       <img [src] = "url" height="200px"/><br>
    <input type="file" id="img" style="display:none" (change)="onselectFile($event)" />
    <label for="img">Upload image</label>
  </div>
-->
</section>


<div class="container">
  <div class="modal fade" id="deleteReturnModal1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteReturn(trackData)">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>
